export const SYSADMIN_ROLE = 'sysadmin';
export const AUTHOR_ROLE = 'author';
export const EXPERT_ROLE = 'expert';
export const VENDOR_ROLE = 'vendor';
export const TESTER_ROLE = 'tester';
export const ROLES = [SYSADMIN_ROLE, AUTHOR_ROLE, EXPERT_ROLE, VENDOR_ROLE, TESTER_ROLE];